var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('product-template',{attrs:{"product":_vm.box,"likes":_vm.likes,"initQuantity":0,"inCart":true,"isBox":true,"status":_vm.PRODUCT_STATUS.shelf,"showFreq":true,"withLikes":_vm.authenticated,"oneShot":_vm.box.isOneShotable}})}
var staticRenderFns = []

export { render, staticRenderFns }